import { categories } from "@/mocks/positiveNews";

const supportLinks = [
  { href: "#about", label: "关于本站" },
  { href: "#faq", label: "常见问题" },
  { href: "#contact", label: "投稿联系" },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          {/* 品牌 */}
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-background-950">
                <i className="ri-community-fill text-lg" />
              </span>
              <span className="font-heading text-2xl font-bold text-background-50">红黑料 · 正面爆料</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              看腻了负面，来这里换换口味。专注好人好事、红料合集与高光时刻，让每一次善意的选择都被看见、被记住。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="mailto:hello@example.com"
                rel="nofollow"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300/50 px-4 py-2 text-sm text-background-100 transition-colors hover:bg-background-50/10 cursor-pointer"
              >
                <i className="ri-mail-send-line" />
                hello@example.com
              </a>
            </div>
          </div>

          {/* 栏目 */}
          <div>
            <h4 className="font-heading text-base font-bold text-background-50">内容栏目</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.map((c) => (
                <li key={c.key}>
                  <a href="#categories" className="text-sm text-background-300 transition-colors hover:text-accent-300 cursor-pointer">
                    {c.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 导航支持 */}
          <div>
            <h4 className="font-heading text-base font-bold text-background-50">浏览帮助</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li>
                <a href="#hot" className="text-sm text-background-300 transition-colors hover:text-accent-300 cursor-pointer">最新热点</a>
              </li>
              <li>
                <a href="#featured" className="text-sm text-background-300 transition-colors hover:text-accent-300 cursor-pointer">本期高光</a>
              </li>
              <li>
                <a href="#collections" className="text-sm text-background-300 transition-colors hover:text-accent-300 cursor-pointer">红料合集</a>
              </li>
              <li>
                <a href="#people" className="text-sm text-background-300 transition-colors hover:text-accent-300 cursor-pointer">人物特写</a>
              </li>
              {supportLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-background-300 transition-colors hover:text-accent-300 cursor-pointer">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-300/20 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">© 2026 红黑料正面爆料 · 本站专注正面内容，力求真实，欢迎监督指正。</p>
          <p className="flex items-center gap-1.5 text-xs text-background-400">
            <i className="ri-heart-3-fill text-accent-400" />
            愿善意被看见
          </p>
        </div>
      </div>
    </footer>
  );
}